import { PaymentProvider } from "@brookbush/database";

import { useAuth } from "@clerk/nextjs";
import type Stripe from "stripe";
import useSWR from "swr";

import useSubscriptionDB from "./useSubscriptionDB";
import fetcher from "~/utils/fetcher.client";

const useStripeSubscriptionFailed = () => {
	const { userId } = useAuth();

	const { subscriptionDB } = useSubscriptionDB();

	const isRequired =
		subscriptionDB &&
		subscriptionDB.paymentProvider === PaymentProvider.STRIPE &&
		subscriptionDB.status !== "ACTIVE" &&
		subscriptionDB.status !== "TRIALING";

	const { data: failedSubscriptionError, isLoading } =
		useSWR<Stripe.PaymentIntent.LastPaymentError>(
			userId && isRequired && `/stripe/subscriptions/failed`,
			fetcher,
		);

	return { failedSubscriptionError, isLoading };
};

export default useStripeSubscriptionFailed;
